import React from 'react';
import styles from './services.module.scss';
import useServicesHook from './services-hook';
import { ICompanyResponse } from '../../../../../Interfaces/responseTypes';

export interface ISevicesProps {
    data: ICompanyResponse;
    onUpdate: () => void
}

const Services: React.FC<ISevicesProps> = (props) => {
    const {
        navRef,
        navItemRefs,
        PAGE_CONTENTS,
        activeContent,
        serviceActions,
        handleNavClick,
    } = useServicesHook(props);

    return (
        <div className={styles.container}>
            <div className={styles.page}>
                <div className={styles.servicesHeader} ref={navRef}>
                    {
                        serviceActions.map((action, index) => {
                            return (
                                <div
                                    key={action.id}
                                    className={activeContent === action.id ? styles.selectedAction : styles.actionItem}
                                    onClick={() => handleNavClick(index, action.id)}
                                    ref={(el) => (navItemRefs.current[index] = el)}
                                >
                                    <img src={action.icon} alt={`${action.icon}.svg`} />
                                    <p>{action.title}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={styles.pageContent}>
                {PAGE_CONTENTS[activeContent]}
                </div>
            </div>
        </div>
    )
}

export default Services
